import JwtService from '@/services/jwt.service';


const user = JwtService.getUser();
// console.log("user", user);

const initialState = {
  isAuthenticated: user ? true : false,
  user: user ? user : {},
  errors: {},
  // webSocketClient: webSocketClient
}; // can load from localStorage

console.log(initialState);
export default {
  ...initialState
}
